import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope, EnvelopeDraft } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const createSignatureDraft = (
  constructPost: ConstructPost,
  envelope: Envelope,
): Promise<NonPaginatedResponse<EnvelopeDraft> | undefined> =>
  constructPost<NonPaginatedResponse<EnvelopeDraft>>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelope.id}/drafts`,
    undefined,
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
